import {Component, Input, OnInit} from '@angular/core';
import {SkillsCheckerModel} from '../../model/skills-checker.model';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../../../services/analytics.service';

@Component({
    selector: 'app-skills-checker-team-card',
    templateUrl: './skills-checker-team-card.component.html',
    styleUrls: ['./skills-checker-team-card.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    ]
})
export class SkillsCheckerTeamCardComponent implements OnInit {
    @Input() data: SkillsCheckerModel;
    @Input() i: number;

    constructor(
        private analytics: AnalyticsService,
        private router: Router,
    ) {
    }

    ngOnInit() {
    }

    openDevReport() {
        this.router.navigate(['/skills-checker/development/user', this.data.delegate.id, this.data.id]);
    }

    onEdit() {
        if (this.data.completed.agreed) {
            this.router.navigate(['/skills-checker/form/agreed/', this.data.delegate.id, this.data.id]);
        } else if (this.data.completed.manager) {
            this.router.navigate(['/skills-checker/form/agreed/', this.data.delegate.id, this.data.id]);
        } else if (this.data.completed.self) {
            this.router.navigate(['/skills-checker/form/manager/', this.data.delegate.id, this.data.id]);
        }
    }
}
